import { Component, HostListener, OnInit, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

    constructor(
        public sidenav: SidenavService,
        private el: ElementRef
    ) { }

    public community_logo: any = null;

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        if (window.innerWidth <= 991) {
            this.sidenav.close();
        } else {
            this.sidenav.open();
        }
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.el.nativeElement.querySelectorAll('a.nav-link.active')?.[0]?.scrollIntoView();
        }, 1000);
    }
}
